import { getMedicationSearchList } from '../../actions'
import DOMPurify from 'dompurify';

export class HealthHistoryMedicationForm {
  constructor(el) {
    this.calendarIconPath = el.querySelector('input#calendar_icon_path').value

    //Medication Elements
    this.medicationSearchField = el.querySelector('[data-component="medication-search"]')
    this.medicationResultList = el.querySelector('#medication-result-list')
    this.medicationSelectionList = el.querySelector('#medication-selection-list')

    //Medication Event Listeners
    this.medicationSearchField.addEventListener('keyup', (e) => this.onMedicationSearchFieldChange(e, this.medicationResultList))
    this.medicationResultList.addEventListener('click', (e) => this.onMedicationSelection(e))
    this.medicationResultList.addEventListener('keyup', (e) => this.onMedicationSelection(e))
    this.medicationSelectionList.addEventListener('click', (e) => this.handleMedicationEntryClicks(e))
    this.medicationSelectionList.addEventListener('keyup', (e) => this.handleMedicationEntryClicks(e))
    this.medicationSelectionList.addEventListener('change', (e) => this.handleMedicationEntryClicks(e))

    this.medicationSelectionList.innerHTML = DOMPurify.sanitize(sessionStorage.medicationSelectionList || '')

    this.medicationSelectionList.querySelectorAll('div.dp-container input').forEach((item) => {
      this.intakeMDYDatePickerInitialize(item)
    })
  }

  onMedicationSearchFieldChange(event, medicationResultList) {
    if (event.srcElement.value.length > 2) {
      medicationResultList.classList.add('searching')
      medicationResultList.innerHTML = '<li>Loading ...</li>'
      getMedicationSearchList({ search_term: event.srcElement.value, athena_context_id: event.srcElement.dataset.athenaContextId }).then(function (results) {
        let medicationListItems = ''
        results.data.forEach(function (result) {
          medicationListItems +=
            '<li data-medicationid="' + result.medicationid + '" tabindex="0">' + result.medication + '</li>'
        })
        if (medicationListItems.length == 0) {
          medicationListItems = '<li>No medications found. Please try another search term.</li>'
        }
        medicationResultList.innerHTML = medicationListItems
      })
    } else {
      medicationResultList.innerHTML = ''
      medicationResultList.classList.remove('searching')
    }
  }

  handleMedicationEntryClicks(event) {
    // return false if keyboard event is not enter key
    if (this.isNotEnterClick(event)) {
      return false
    }

    // check for request to close element
    this.removeEntryCheck(event, this.medicationSelectionList, 'medicationSelectionList')
  }

  removeEntryCheck(event, list, listType) {
    if (event.target && event.target.classList.contains('remove-medication')) {
      list.removeChild(event.target.closest('li'))
      sessionStorage.setItem(listType, list.innerHTML)
    }
  }
  saveDateChanges(event, list, listType) {
    if (event.target && event.target.className == 'datepicker' && event.type == 'change') {
      event.target.setAttribute('value', event.target.value)
      this.setHtmlSegment(listType, list.innerHTML, true)
    }
  }


  onMedicationSelection(event) {
    if (this.isNotEnterClick(event) || typeof event.target.dataset.medicationid == 'undefined') {
      return false
    }
    this.createMedicationEntry(event.target.innerText, event.target.dataset.medicationid)
    this.medicationResultList.innerHTML = ''
    this.medicationResultList.classList.remove('searching')
    this.medicationSearchField.value = ''
  }

  createMedicationEntry(name, id) {
    let key = new Date().getTime()
    this.setHtmlSegment('medicationSelectionList',
      `<li>
        <input
          name="telemedicine_intakes_v2_health_history_medication_form[intake_health_history_medications][${key}][medicationid]"
          value="${id}"
          type="hidden"
        />
        <div class="datepicker-wrapper">
          <label for="intake_health_history_medications_${key}_startdate">
            Approximately when did you start taking <b>${name}</b>?<span class="required">*</span>
          </label>
          <div class="dp-container">
            <input
              id="intake_health_history_medications_${key}_startdate"
              name="telemedicine_intakes_v2_health_history_medication_form[intake_health_history_medications][${key}][startdate]"
              type="text"
              class="datepicker"
              placeholder="Please pick a date"
              data-mode="date"
              role="combobox"
              aria-haspopup="dialog" 
              aria-expanded="false" 
              autocomplete="off" 
              readonly="readonly"
              data-end-date="${new Date().toLocaleDateString('en-US')}"
              required="required"
            />
            <img src="${this.calendarIconPath}" alt="Privia Health" class="patcom-calendar-image pick-a-date" />
            <i class="fas fa-times remove-medication"></i>
          </div>
        </div>
      </li>`
    )
  }

  setHtmlSegment(name, content, override = false) {
    content = (sessionStorage.getItem(name) && !override) ? content + sessionStorage.getItem(name) : content
    sessionStorage.setItem(name, content)
    this[name].innerHTML = DOMPurify.sanitize(content)

    this[name].querySelectorAll('div.dp-container input').forEach((item) => {
      this.intakeMDYDatePickerInitialize(item)
    })
  }

  isNotEnterClick(event) {
    return (event instanceof KeyboardEvent && event.which != 13)
  }

  /*
    vendor/jquery-1.7.2 and bootstrap-datepicker are necessary to make this method work
    which are declared in app/assets/javascripts/telemedicine_intakes_v2.js
  */
  intakeMDYDatePickerInitialize(item) {
    let that = this

    // DatePicker recreation
    new DatePicker(item)

    jQuery(item).on('change', function (e) {
      // Check for date changes and save to session
      that.saveDateChanges(e, that.medicationSelectionList, 'medicationSelectionList')
    })
  }
}